import { sseApiClient } from '../utils/axios';
import { SseListener } from '../types/Sse';

export const fetchAllListeners = async (): Promise<SseListener[]> => {
  return (await sseApiClient.get('/api/sse/listeners/all')).data;
};
